module.exports = __webpack_public_path__ + "static/media/Jackpot_displayed_screen@3x.64f12ca8.png";